import React, { useState, useEffect } from "react";
import Serviceclasses from "./Service.module.css";
import {
  getAllServices,
  getAllServiceByCategoryIdAndSubCategory,
  getAllCategoryWithServices,
} from "../../../Services/APIrequests";
import { BsFillBuildingsFill } from "react-icons/bs";
import {
  useNavigate,
  useLocation,
  useSearchParams,
  useParams,
} from "react-router-dom";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import defaultIMG from "../../../Assets/defaultimg.png";
import parse from 'html-react-parser';

// Component for rendering individual service cards
const ServiceCard = ({ service }) => {
  const navigate = useNavigate();
  const {
    title,
    shortDescription,
    thumbnailUrl,
    serviceId,
    servicePrice,
    isPriceShown,
  } = service;
  const defaultImage = "https://via.placeholder.com/150";


  const handleClick = (serviceId, title) => {
    // navigate(`/services/${serviceId}/${title}`);
    navigate(
      `/services/${service.serviceId}/${encodeURIComponent(
        service.title.replace(/\s+/g, "-")
      )}`
    );
  };

  return (
    <div
      className={Serviceclasses.Servicecard}
      onClick={() => handleClick(serviceId)}
    >
      <div className={Serviceclasses.ServicecardImage}>
        <img
          src={thumbnailUrl || defaultImage}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = defaultIMG;
          }}
          alt={title}
        />
      </div>
      <div className={Serviceclasses.Servicecard2}>
           <div className={Serviceclasses.ServicecardContent}>
        <div className={Serviceclasses.ServicecardFooter}>
          <h2 className={Serviceclasses.ServicecardTitle}>{title}</h2>
          <div className={Serviceclasses.ServiceIcon}>
            <BsFillBuildingsFill />
          </div>
        </div>
     
          {/* <p className={Serviceclasses.Servicecsmallarddescr}>
            {shortDescription || "Description not available"}
          </p> */}
          <p className={Serviceclasses.Servicecsmallarddescr}>
  {shortDescription ? parse(shortDescription) : "Description not available"}
</p>
        </div>
        <div className={Serviceclasses.Servicecard_readmore}>
          <div
            className={Serviceclasses.ServicecardLink}
            onClick={() => handleClick(serviceId, title)}
          >
            Read More
          </div>
          {isPriceShown === 1 && (
            <div className={Serviceclasses.ServicecardLink}>
              <RiMoneyRupeeCircleFill
                className={Serviceclasses.ServicecardLink_icon}
              />
              {servicePrice}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Component for rendering the service list based on filters
const Serviceclassess = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [categoriesWithServices, setCategoriesWithServices] = useState([]);
  const { name } = useParams(); // Get category name from URL

  // Function to fetch all categories with services
  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await getAllCategoryWithServices();
      const categoryName = name.replace(/_/g, " ");
      if (Array.isArray(response.data?.categoriesWithServices)) {
        setCategoriesWithServices(
          response.data?.categoriesWithServices?.find(
            (item) => item.categoryName === categoryName
          )?.services
        );
        console.log(
          response.data?.categoriesWithServices?.find(
            (item) => item.categoryName == name
          )
        );
      } else {
        console.error(
          "API response is not an array:",
          response.data?.categoriesWithServices
        );
      }
    } catch (err) {
      console.error("Error fetching services:", err);
    } finally {
      setLoading(false);
    }
  };

  // Effect to fetch services on component load and when 'name' (category name) changes
  useEffect(() => {
    fetchServices();
  }, [name, searchParams]);

  return (
    <div style={{ backgroundColor: "#f5fff8" }}>
      <div className={Serviceclasses.Servicecontainer}>
        <h1>
          Explore Our <span>{name.replace(/_/g, " ")}</span>
        </h1>
        <div className={Serviceclasses.ServicecardGrid}>
          {categoriesWithServices && categoriesWithServices.length > 0 ? (
            categoriesWithServices.map((service) => (
              <ServiceCard key={service.serviceId} service={service} />
            ))
          ) : (
            <p>No services available for this category.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Serviceclassess;
